module.exports = __webpack_public_path__ + "static/media/background-werk2.0a5b739c.jpg";